<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="地图服务名称">
          <el-input placeholder="请输入地图服务名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加地图服务</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
              <!-- 地图服务名称 -->
  <el-table-column prop="name" label="地图服务名称" min-width="150"></el-table-column>
  
  <!-- 原价（带货币格式化） -->
  <el-table-column prop="price" label="原价" width="120">
    <template #default="{row}">
      {{ row.price  }}
    </template>
  </el-table-column>
  
  <!-- 优惠价（突出显示） -->
  <el-table-column prop="yprice" label="优惠价" width="120">
    <template #default="{row}">
      <span style="color: #F56C6C; font-weight: 500;">{{ row.yprice }}</span>
    </template>
  </el-table-column>
  
  <!-- 优惠结束时间（日期格式化） -->
  <el-table-column prop="ytime" label="优惠截止" width="180">
    <template #default="{row}">
      {{ row.ytime }}
      <!-- <el-tag v-if="isExpired()" size="mini" type="danger" effect="dark">已过期</el-tag> -->
    </template>
  </el-table-column>
  
  <!-- 关联平台（多平台标签显示） -->
  <el-table-column prop="platforms" label="支持平台" min-width="200">
    <template #default="{row}">
      <el-tag 
        v-for="platform in row.platforms" 
        :key="platform.platformm_id"
        size="small"
        style="margin-right: 5px; margin-bottom: 5px;">
        {{ platform.name }}
      </el-tag>
      <span v-if="row.platforms.length === 0">无</span>
    </template>
</el-table-column>
  
  <!-- 月销（带排序功能） -->
  <el-table-column prop="sales" label="月销" sortable width="100">
    <template #default="{row}">
      {{ row.sales | numberFormat }}
    </template>
  </el-table-column>
  
  <!-- 虚拟月销（气泡提示） -->
  <el-table-column prop="xsales" label="虚拟月销" width="120">
    <template #default="{row}">
      <el-tooltip content="虚拟销量用于前台展示" placement="top">
        <span>{{ row.xsales | numberFormat }}</span>
      </el-tooltip>
    </template>
  </el-table-column>

   <el-table-column prop="discount" label="优惠比例" width="150">
    <template #default="{row}">
      <el-progress 
        :percentage="row.discount" 
        :color="rateColor(row.discount)"
        :show-text="false"
        :stroke-width="16">
      </el-progress>
      <span style="margin-left: 8px;">{{ row.discount }}%</span>
    </template>
  </el-table-column>
  
  <!-- 好评率（进度条显示） -->
  <el-table-column prop="rate" label="好评率" width="150">
    <template #default="{row}">
      <el-progress 
        :percentage="row.rate" 
        :color="rateColor(row.rate)"
        :show-text="false"
        :stroke-width="16">
      </el-progress>
      <span style="margin-left: 8px;">{{ row.rate }}%</span>
    </template>
  </el-table-column>
  

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :dservice_id="dservice_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import DserviceApi from '@/api/dservice.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    filters: {

    numberFormat(value) {
      return (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

  },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        dservice_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
   
    rateColor(rate) {
      if (rate >= 90) return '#67C23A'
      if (rate >= 70) return '#409EFF'
      if (rate >= 50) return '#E6A23C'
      return '#F56C6C'
    },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//地图服务标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DserviceApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.dservice_id = row.dservice_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DserviceApi.del(
              {
                dservice_id: row.dservice_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/dservice/index/index.vue